import { PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';
import '@fontsource/inter/400.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
import '@fontsource/sora/400.css';
import '@fontsource/sora/600.css';
import '@fontsource/sora/700.css';
import '@fontsource/sora/800.css';
import { GlobalStyles } from '../styles/GlobalStyles';
import { themeMain } from '../styles/theme';

const Styles = ({ children }: PropsWithChildren) => (
  <ThemeProvider theme={themeMain}>
    <GlobalStyles />
    {children}
  </ThemeProvider>
);

export { Styles };
